"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _qs = _interopRequireDefault(require("qs"));

var _baseclient = _interopRequireDefault(require("./baseclient"));

var LOUDSPEAKER_BASE_URL = 'https://loudspeakerapi.fi.cimpress.io';
/**
 * Provides access to the Loudspeaker server for reading announcements.
 */

var LoudspeakerClient =
/*#__PURE__*/
function (_BaseClient) {
  (0, _inherits2.default)(LoudspeakerClient, _BaseClient);

  function LoudspeakerClient() {
    (0, _classCallCheck2.default)(this, LoudspeakerClient);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(LoudspeakerClient).apply(this, arguments));
  }

  (0, _createClass2.default)(LoudspeakerClient, [{
    key: "getAnnouncements",

    /**
     * Retrieve the announcements for a given channel. Optionally provide before and after timestamps
     * to narrow down the results.
     * @param {Object} queryParameters Object with query parameters
     */
    value: function () {
      var _getAnnouncements = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(queryParameters) {
        var announcements, url, response;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                announcements = [];
                url = "".concat(LOUDSPEAKER_BASE_URL, "/v2/channels/").concat(this.channelId, "/announcements");

                if (queryParameters) {
                  url = "".concat(url, "?").concat(_qs.default.stringify(queryParameters));
                }

                _context.prev = 3;
                _context.next = 6;
                return fetch(url, {
                  method: 'GET',
                  headers: this.headers
                });

              case 6:
                response = _context.sent;

                if (response.ok) {
                  _context.next = 9;
                  break;
                }

                throw new Error("Loudspeaker: Unable to retrieve announcements from ".concat(this.channelId));

              case 9:
                _context.next = 11;
                return response.json();

              case 11:
                announcements = _context.sent;
                _context.next = 17;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](3);
                console.warn(_context.t0.message);

              case 17:
                return _context.abrupt("return", announcements);

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 14]]);
      }));

      return function getAnnouncements(_x) {
        return _getAnnouncements.apply(this, arguments);
      };
    }()
  }]);
  return LoudspeakerClient;
}(_baseclient.default);

exports.default = LoudspeakerClient;